export enum SearchParameter {
    InternID = 1,
    TEAID = 2
}
